import React from "react"
import { array, string, shape, bool, func } from "prop-types"
import classNames from "classnames"

import ThemeConsumer from "../ThemeConsumer"
import Tooltip from "react-tooltip-lite"
import iconQuestion from "assets/svg/question.svg"

const baseLabelStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: 5
}

const RadioButton = ({
  theme,
  direction,
  separationLine,
  onChange,
  options
}) => {
  const handleOptions = () => {
    return options.map((item) => {
      const rootClass = classNames({
        [theme.horizontalRoot]: direction !== "vertical",
        [theme.verticalRoot]: direction === "vertical",
        "u-textLeft": direction === "vertical",
        [theme.separationLine]: separationLine
      })

      const labelClass = classNames(theme.container, {
        [theme.horizontal]: direction === "horizontal"
      })

      return (
        <div key={item.id} className={rootClass}>
          <label className={labelClass} style={baseLabelStyle}>
            {item.label}
            <input
              type="radio"
              value={item.value}
              checked={item.checked}
              name={item.name || item.id || "Radio"}
              onClick={(e) => onChange(e)}
            />
            <span className={theme.checkmark}></span>
            {item.contentTooltip && (
              <Tooltip
                background={"white"}
                direction="up"
                tagName="span"
                content={
                  <div>
                    <p>{item.contentTooltip || ""}</p>
                  </div>
                }
              >
                <sup>
                  <img width={8} src={iconQuestion} alt="icone de informação" />
                </sup>
              </Tooltip>
            )}
          </label>
        </div>
      )
    })
  }

  return <div className={`${direction}`}>{handleOptions()}</div>
}

RadioButton.propTypes = {
  options: array,
  id: string,
  theme: shape({
    horizontalRoot: string,
    verticalRoot: string
  }),
  direction: string,
  separationLine: bool,
  onChange: func
}

RadioButton.defaultProps = {
  options: []
}

export default ThemeConsumer("UIRadioButton")(RadioButton)



// WEBPACK FOOTER //
// ./src/shared/components/RadioButton/index.js